export enum TemplatesApi {
  Templates = '/WebAPI/GetTemplatesAsync',
  Template = '/WebAPI/getTemplate'
}
